__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/52a1339/_next/";